import Vue from 'vue';

export default {
  state: {
    shippingOptions: null,
  },
  getters: {
    SHIPPING_OPTIONS: state => {
      return state.shippingOptions;
    },
  },
  mutations: {
    SET_SHIPPING_OPTIONS: (state, payload) => {
      state.shippingOptions = payload;
    },
  },
  actions: {
    INIT_SHIPPING_OPTIONS: async (context, data) => {
      const loader = Vue.$loading.show();

      try {
        const response = await Vue.axios.post('v2/shipping_options', data);

        let shippingOptions = [];

        response.data.data.forEach((option) => {
          shippingOptions.push({
            id: option.id,
            shippingOptionId: parseInt(option.shipping_option_id),
            shippingRateId: option.shipping_rate ? option.shipping_rate.id : null,
            title: option.title,
            address: option.additional_text,
            price: option.shipping_rate
                ? parseFloat(option.shipping_rate.shipping_fee_gross)
                : 0,
          });
        });

        if (typeof response.data.individual_shipping !== 'undefined') {
          shippingOptions.push({
            id: response.data.individual_shipping.id,
            shippingOptionId: 4,
            shippingRateId: null,
            title: response.data.individual_shipping.title,
            address: response.data.individual_shipping.address,
            price: 0,
          });
        }

        context.commit('SET_SHIPPING_OPTIONS', shippingOptions);
        loader.hide();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
        loader.hide();
      }
    },
  },
};